module.exports = __webpack_public_path__ + "img/amxlkl.9f8bb818.png";